import styles from '@/legacy/components/Text/text.module.scss';

type Props = {
	prefix: string;
	suffix: string;
};

const BulletSplitBodyM16 = ({ prefix, suffix }: Props) => {
	return (
		<span className={styles.dateInfo}>
			{prefix} • {suffix}
		</span>
	);
};

export default BulletSplitBodyM16;
